/** @format */

import { createSlice } from '@reduxjs/toolkit';

const pageModificationSlice = createSlice({
  name: "pageModification",
  initialState: {
    addedPageData: [],
    deletedPageData: [],
  },
  reducers: {
    addPage(state, action) {
      const { payload } = action;
      let newPayload = payload;

      // Remove from deletedPageData if it exists
      const deleteIndex = state.deletedPageData.indexOf(payload);
      if (deleteIndex !== -1) {
        state.deletedPageData.splice(deleteIndex, 1);
        return;
      }

      // Check if payload already exists in addedPageData
      if (state.addedPageData.includes(payload)) {
        // If not, find a unique payload
        while (state.addedPageData.includes(newPayload)) {
          newPayload++;
        }
        state.addedPageData.push(newPayload);
      } else {
        state.addedPageData.push(payload);
      }
    },

    deletePage(state, action) {
      const { payload } = action;
      let newPayload = payload;

      // Remove from addedPageData if it exists
      const addIndex = state.addedPageData.indexOf(payload);
      if (addIndex !== -1) {
        state.addedPageData.splice(addIndex, 1);
        return;
      }

      // Check if payload already exists in deletedPageData
      if (state.deletedPageData.includes(payload)) {
        // If not, find a unique payload
        while (state.deletedPageData.includes(newPayload)) {
          newPayload++;
        }
        state.deletedPageData.push(newPayload);
      } else {
        state.deletedPageData.push(payload);
      }
    },
    updatePageData(state, action) {
      const { payload } = action;
      return { addedPageData: payload, deletedPageData: payload };
    },
  },
});

export const { addPage, deletePage, updatePageData } =
  pageModificationSlice.actions;
export default pageModificationSlice.reducer;
